import { useState } from "react";
import ProductCard from "@/components/feature/ProductCard";
import { lookProducts } from "@/mocks/products";

export default function ShopTheLook() {
  const [active, setActive] = useState(0);

  return (
    <section id="looks" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <header className="text-center mb-12 md:mb-16">
          <p className="font-label text-[11px] md:text-xs tracking-[0.28em] uppercase text-foreground-500 mb-3">
            Shop
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-light tracking-[0.16em] uppercase text-foreground-950">
            Our Looks
          </h2>
        </header>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[62%]">
            <div className="relative w-full aspect-[4/3] overflow-hidden bg-accent-100">
              <img
                src="https://sofiajewelry.com/cdn/shop/files/2_3.progressive.jpg?v=1677876124"
                alt="Stylish woman showcasing her stack of rings, highlighting a mesmerizing 18k yellow gold diamond band"
                title="Our Looks — Sofia Jewelry"
                className="w-full h-full object-cover object-top"
              />
              {lookProducts.map((product, i) => (
                <button
                  key={product.id}
                  type="button"
                  aria-label={`View ${product.title}`}
                  onClick={() => setActive(i)}
                  className={`absolute rounded-full w-5 h-5 flex items-center justify-center transition-all cursor-pointer ${
                    i === 0 ? "left-[34%] top-[58%]" : "left-[52%] top-[66%]"
                  }`}
                >
                  <span
                    className={`w-3 h-3 rounded-full border border-background-50 transition-colors ${
                      active === i ? "bg-primary-500" : "bg-background-50/70"
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[38%]">
            <div className="max-w-[280px] mx-auto lg:mx-0">
              <ProductCard product={lookProducts[active]} showVendor={false} />
              <a
                href={lookProducts[active].href}
                className="mt-6 block text-center bg-primary-500 hover:bg-primary-600 text-foreground-950 font-label text-xs tracking-[0.22em] uppercase px-6 py-3.5 rounded-md transition-colors whitespace-nowrap"
              >
                View This Product
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}